import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';

@Component({
    selector: 'okta-callback',
    templateUrl: './okta-custom-callback.component.html',
    styleUrls: ['./okta-custom-callback.component.css'],
  })
export class OktaCustomCallbackComponent implements OnInit{
  errorMessage: string = ''
  constructor(private oktaAuthService: OktaAuthService,private router: Router,) { }
    async ngOnInit() {
        try{
          await this.oktaAuthService.handleAuthentication();
        }catch(error){
          this.errorMessage = error;
          console.log('error from okta' + error);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/okta-custom-callback/okta-custom-callback.component.ts